import React from "react";
import {useEffect, useRef } from "react";
import { useScroll, useTransform, MotionValue, motion} from "framer-motion";
import { Link } from "react-router-dom";

import 'style.css';
export default function WelcomePage() {

    const container = useRef<HTMLDivElement | null>(null);
    const {scrollYProgress} = useScroll({
        target: container,
        offset: ["start start", "end end"]
    })

    useEffect( ()=> {

    }, [])
    return (
        <main ref={container} style={{ position: 'relative', zIndex: 1 }}>
            <Section1 scrollYProgress = {scrollYProgress}/>
            <Section2 scrollYProgress = {scrollYProgress}/>
            <Section3 scrollYProgress = {scrollYProgress}/>
        </main>
    );
}

interface SectionProps {
    scrollYProgress: MotionValue<number>;
}

const Section1: React.FC<SectionProps> = ({scrollYProgress}) => {
    const {filter} = useTransform(scrollYProgress, [0.1, .5], {
        // opacity: [1, -1],
        // scale: [1, 0.5],
        filter: ["brightness(100%)", "brightness(30%)"],
        // rotate: [0, -15],
    })
    // const scale = useTransform(scrollYProgress, [0, 1], [1, .5])
    // const rotate = useTransform(scrollYProgress, [0, 1], [0, -15])

    return (
        <motion.div className="grid-item" id="Section1" style={{
            backgroundImage: "linear-gradient(180deg, rgba(0, 0, 0, 0.05) 0%, rgba(0, 0, 0, .5) 100%), url('/images/gallery/JesseHall.jpg')",
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            // opacity,
            // scale,
            filter,
            // rotate,
        }}>
            <div className="description">
                <h4>Students' Underwater Robotics Foundation</h4>
                <h3>MU SURF</h3>
                <p>SURF is a club at Mizzou that participates in the international robotics competition RoboSub.
                 This competition focuses on the underwater maritime industry and challenges associated with it.
                 We build an Autonomous Underwater Vehicle (AUV).
                  This is very challenging because we need to organize and cooperate between different sub-teams within our club.</p>

                <div className="btn">
                    <Link to="/our-team">
                        <button>Learn more!</button>
                    </Link>
                </div>
            </div>
        </motion.div>
    )
}
const Section2: React.FC<SectionProps> = ({scrollYProgress}) => {
    // const scale = useTransform(scrollYProgress, [0, 1], [.8, 1])
    // const rotate = useTransform(scrollYProgress, [0, 1], [-5, 0])
    const {filter} = useTransform(scrollYProgress, [.5, .85], {
        // opacity: [1, -3],
        // scale: [1, 0.5],
        filter: ["brightness(100%)", "brightness(30%)"],
        // rotate: [-5, 0],
    })
    return (
        <motion.div className="grid-item" id="Section2"style={{
            backgroundImage: "linear-gradient(180deg, rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, .5) 100%), url('/images/gallery/subInWater.jpg')",
            backgroundSize: "cover",
            objectPosition: "100% 20%",
            backgroundPosition: "80% 20%",
            // opacity,
            // scale,
            filter,
            // rotate,
        }}> 
            <div className="description" id="Sub-Teams_Description" style={{
                // alignContent: "right",
                // margin: "6rem 600px",
                // marginRight: "0px",
            }}>
                <h4>Understand the process:</h4>
                <h3>Sub-Teams</h3>
                {/* <Logo/> */}
                <p>SURF is comprised of 3 main Sub-Teams (get it?). 
                    We have a mechanical team, an electrical team, and a software team. 
                    Each has its own goals and objectives. 
                    Without these teams of concentrated knowledge and skill, nothing would get done!</p>

                <div className="btn">
                    <Link to="/process">
                        <button>Learn more!</button>
                    </Link>
                </div>
            </div>
        </motion.div>
    )
}
const Section3: React.FC<SectionProps> = ({scrollYProgress: _scrollYProgress}) => {
    return (
        <motion.div className="grid-item" id="Section3" style={{
            backgroundImage: "url('/images/gallery/roboSubCompetition.jpg')",
            backgroundSize: "cover",
            objectPosition: "100% 20%",
            objectFit: "cover",
            backgroundPosition: "80% 20%",
        }}>

            <div className="description"> 
                <h3>Officers</h3>
                <p>
                    Our officers are long-standing members of the club who have been elected by their peers to take on a leadership role. 
                    Their positions reflect both their experience within the organization and the confidence their 
                    fellow members have placed in them to move the club forward.
                </p>
                <div className="btn">
                    <Link to="/our-team#officers">
                        <button>Meet Them!</button>
                    </Link>
                </div>
            </div>
        </motion.div>
    )
}